import { useEffect } from 'react';
import { useRouter } from 'next/router';

import styles from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';
import { singleAxisShopifyLinkMap } from '@/constants/powerStream';

export default function Fits() {
    const { locale } = useRouter();
    const { t } = useLang('powerstream.detail.fits');

    const singleAxisLink = singleAxisShopifyLinkMap[locale as string] || singleAxisShopifyLinkMap.uk;

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.fit-section .fit-img', { y: 0 }, { y: 300 }, 1]],
            triggerElement: '.fit-section',
            offset: '30%',
            duration: '170%',
            triggerHook: 1,
        });
    }, []);

    return (
        <div className={styles.fits}>
            <div className="fit-section">
                <div className="fit-box">
                    <p className="fit-title">
                        {t.rich('title', {
                            HighLight: (text: string) => <span className="green-text">{text}</span>,
                        })}
                    </p>
                    <p className="fit-desc">{t('desc')}</p>
                </div>
                <div className="fit-img-box">
                    <div className="fit-img">
                        <NextImage
                            src={require('@publicLocal/power-stream/detail/pc/fit_bg.jpg')}
                            webpSrc={require('@publicLocal/power-stream/detail/pc/fit_bg.webp')}
                        />
                    </div>
                </div>
            </div>
            <div className="scene-section">
                <div className="house-box">
                    <div className="left-box">
                        <div className="balcony-img">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/balcony_img.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/balcony_img.webp')}
                            />
                        </div>

                        <div className="info-item">
                            <p className="info-text">{t('balcony')}</p>
                            <p className="info-desc">
                                {t.rich('balconyDesc', {
                                    HighLight: (text: string) => (
                                        <a href={singleAxisLink} className="blue-text" target="_blank">
                                            {text}
                                        </a>
                                    ),
                                })}
                            </p>
                        </div>
                        <div className="info-item">
                            <p className="info-text">{t('terrace')}</p>
                            <p className="info-desc">{t('terraceDesc')}</p>
                        </div>
                    </div>
                    <div className="right-box">
                        <p className="big-text">{t('house')}</p>

                        <div className="garden-img">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/garden_img.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/garden_img.webp')}
                            />
                        </div>
                    </div>
                </div>
                <div className="flat-box">
                    <div className="left-box">
                        <div className="info-item">
                            <p className="big-text">{t('flat')}</p>
                            <p className="info-desc">{t('flatDesc')}</p>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="flat-img">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/flat_img.jpg')}
                                // webpSrc={require('@publicLocal/power-stream/detail/pc/flat_img.webp')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
